import { CustomSaveAgreementBinProjectObject } from "types";
import { apiGet, apiPost, CRM_API_URI } from "./index";

const agreementProjectSetup = {
  InsertAgreementProject: async (agreementObj: any, ProductTypeId: number) => {
    const data = await apiPost(`${CRM_API_URI}/api/agreement/save/project?ProductTypeId=${ProductTypeId}`, agreementObj);
    return data;
  },
};

export default agreementProjectSetup;
